import React, { useState, useContext, useEffect } from "react";
import { Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import bg2 from "./Images/bg2.jpg";
import PermissionContext from "../../Store/permission-context";
import { Divider } from "rsuite";
import logoutIcon from "./Images/logoutIcon.png";
import backupIcon from "./Images/backupIcon.png";
import inventoryIcon from "./Images/inventoryIcon.png";
import registeredCustomerIcon from "./Images/registeredCustomerIcon.png";
import salesreportIcon from "./Images/salesreportIcon.png";
import supplyreportIcon from "./Images/supplyreportIcon.png";
import addstockIcon from "./Images/addstockIcon.png";
import goodssummaryIcon from "./Images/goodssummaryIcon.png";
import PaymentAmountIcon from "./Images/PaymentAmountIcon.png";
import salesIcon from "./Images/salesIcon.jpg";
import expensesIcon from "./Images/expensesIcon.png";
import newuserIcon from "./Images/newuserIcon.png";
import viewdebtIcon from "./Images/viewdebtIcon.png";
import viewuserIcon from "./Images/viewuserIcon.png";
import gethistoryIcon from "./Images/gethistoryIcon.png";
import changepasswordIcon from "./Images/changepasswordIcon.png";
import changepriceIcon from "./Images/changepriceIcon.png";
import myreportIcon from "./Images/myreportIcon.png";
import updateserverIcon from "./Images/updateserverIcon.png";
import classes from "./MenuPageDisplay.module.css";
import Cookies from "universal-cookie";
import ExpiredAlert from "./Images/ExpiryAlert.wav";
import NewNotification from "./NewNotification";
const MenuDisplayPage = () => {
  const PCtx = useContext(PermissionContext);
  const cookies = new Cookies();
  const Path = PCtx.ThePath;
  var CryptoJS = require("crypto-js");
  const audioFile = new Audio(ExpiredAlert);
  const [AxiosError, setAxiosError] = useState("");
  const decryption = (Scramb) => {
    let Permission = false;
    if (PCtx.logged) {
      // Scramb = "U2FsdGVkX1/WscdZ+9IV7bHNnXe+9Ptb9Fcv1faThVI=";
      let Scrambled = Scramb.replace(/\s/g, "");
      var bytes = CryptoJS.AES.decrypt(Scrambled, "143tonybridget");
      let Allowance = bytes.toString(CryptoJS.enc.Utf8);
      Permission = parseInt(Allowance) === 1 ? true : false;
    }
    return Permission;
  };
  const [ThereIsExpiredProducts, setThereIsExpiredProducts] = useState(
    PCtx.Expired,
  );
  const [isExpired, setisExpired] = useState(false);
  const [AllMenu, setAllMenu] = useState([
    {
      Name: "New Sales",
      Picture: salesIcon,
      Action: decryption(PCtx.NS) ? "/" + Path + "sales" : "/" + Path + "#",
    },
    {
      Name: "Payment",
      Picture: PaymentAmountIcon,
      Action: decryption(PCtx.PT)
        ? "/" + Path + "orderpayment"
        : "/" + Path + "#",
    },
    {
      Name: "My Report",
      Picture: myreportIcon,
      Action: decryption(PCtx.MR) ? "/" + Path + "myreport" : "/" + Path + "#",
    },
    {
      Name: "Add Stock",
      Picture: addstockIcon,
      Action: decryption(PCtx.SI) ? "/" + Path + "supplyin" : "/" + Path + "#",
    },
    {
      Name: "Change Price",
      Picture: changepriceIcon,
      Action: decryption(PCtx.CP)
        ? "/" + Path + "changeprice"
        : "/" + Path + "#",
    },
    {
      Name: "Add Staff/Customer",
      Picture: newuserIcon,
      Action: decryption(PCtx.ASt)
        ? "/" + Path + "addnewuser"
        : "/" + Path + "#",
    },
    {
      Name: "View Staff",
      Picture: viewuserIcon,
      Action: decryption(PCtx.VS) ? "/" + Path + "viewusers" : "/" + Path + "#",
    },
    {
      Name: "Change Password",
      Picture: changepasswordIcon,
      Action: decryption(PCtx.CPw)
        ? "/" + Path + "changepassword"
        : "/" + Path + "#",
    },
    {
      Name: "Sales Report",
      Picture: salesreportIcon,
      Action: decryption(PCtx.SR) ? "/" + Path + "getreport" : "/" + Path + "#",
    },
    {
      Name: "Supply Report",
      Picture: supplyreportIcon,
      Action: decryption(PCtx.SP)
        ? "/" + Path + "getsupplyreport"
        : "/" + Path + "#",
    },
    {
      Name: "Goods Sales Summary",
      Picture: goodssummaryIcon,
      Action: decryption(PCtx.GS)
        ? "/" + Path + "goodssummary"
        : "/" + Path + "#",
    },
    {
      Name: "Inventory",
      Picture: inventoryIcon,
      Action: decryption(PCtx.IV) ? "/" + Path + "inventory" : "/" + Path + "#",
    },
    {
      Name: "Expenses & Customers",
      Picture: registeredCustomerIcon,
      Action: decryption(PCtx.CR)
        ? "/" + Path + "customersreports"
        : "/" + Path + "#",
    },
    {
      Name: "View Debts",
      Picture: viewdebtIcon,
      Action: decryption(PCtx.VD) ? "/" + Path + "viewdebts" : "/" + Path + "#",
    },
    {
      Name: "Record Expenses",
      Picture: expensesIcon,
      Action: decryption(PCtx.CF) ? "/" + Path + "cashflow" : "/" + Path + "#",
    },
    {
      Name: "Item History",
      Picture: gethistoryIcon,
      Action: decryption(PCtx.GH)
        ? "/" + Path + "gethistory"
        : "/" + Path + "#",
    },

    { Name: "Back - Up", Picture: backupIcon, Action: "/" + Path + "backup" },
    { Name: "Log Out", Picture: logoutIcon, Action: "/" + Path + "home" },
  ]);
  let ConnectionCount = 0;

  const GetClickAction = async (nm, act) => {
    if (nm === "Log Out") {
      const Response = await PCtx.connectAxios(
        "recordlogout.php",
        PCtx.Username,
      );

      cookies.remove("logged", { path: "/" });
      cookies.remove("this_staff", { path: "/" });
      cookies.remove("ExpiredItems", { path: "/" });
      PCtx.GetCookiesValue();
      PCtx.GetCookiesValue();
      PCtx.setExpired(false);

      PCtx.displayAlert(
        "Logged Out",
        "You have been successfully logged out. Bye!",
        "success",
      );
    } else {
      if (nm == "Back - Up") {
        let theresponse = await PCtx.connectAxios("backup.php", "");

        const element = document.createElement("a");
        const file = new Blob([theresponse], { type: "text/plain" });
        element.href = URL.createObjectURL(file);
        let today = new Date().toISOString().slice(0, 10);
        element.download = "BackUp_" + today + ".sql";
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
        PCtx.displayAlert(
          "SUCCESS",
          "Database has been backed up successfully!",
          "success",
        );
      } else {
        if (act === PCtx.RealPath + "/#") {
          PCtx.displayAlert(
            "ACTION DENIED",
            "You are not authorised for this Menu. Contact the Administrator",
            "danger",
          );
        }
      }
    }
  };

  useEffect(() => {
    const GetExpiredGoods = async () => {
      let AllExpiredGoods = await PCtx.connectAxios("getexpiredgoods.php", "");
      // console.log("AllExpiredGoods", AllExpiredGoods);
      // console.log(PCtx.Expired);
      if (
        Array.isArray(AllExpiredGoods) &&
        AllExpiredGoods.length > 0 &&
        !PCtx.Expired
      ) {
        setisExpired(true);
        let soundCount = 0;
        const interval = setInterval(() => {
          if (soundCount < 5) {
            setThereIsExpiredProducts(
              (prevThereIsExpiredProducts) => !prevThereIsExpiredProducts,
            );
            soundCount++;
          } else {
            let d = new Date();
            d.setTime(d.getTime() + 30 * 60 * 1000);
            setThereIsExpiredProducts(true);
            PCtx.setExpired(true);
            cookies.set("ExpiredItems", "Yes", {
              path: "/",
              expires: d,
            });
            clearInterval(interval);
            let eXP = cookies.get("ExpiredItems");
          }
        }, 1000);
      } else {
        setisExpired(false);
        setThereIsExpiredProducts(false);
      }
    };
    GetExpiredGoods();
  }, []);

  useEffect(() => {
    if (ThereIsExpiredProducts && !PCtx.Expired) {
      audioFile.currentTime = 0;
      audioFile.play();
    } else {
      audioFile.currentTime = 0;
      audioFile.pause();
    }
  }, [ThereIsExpiredProducts]);

  return (
    <Row
      className="pb-3"
      style={{
        backgroundImage: `url(${bg2})`,
        backgroundSize: "cover",
      }}
    >
      <Divider className={classes.Welcomemsg}>
        Welcome {PCtx.Username},<br /> Please Pick a Menu below.
      </Divider>
      <Col>
        <Row className={isExpired ? classes.RowHeight : classes.RowHeight2}>
          <Col>{ThereIsExpiredProducts && <NewNotification />}</Col>
        </Row>
        <Row className="px-4 justify-content-around">
          {AllMenu.map((eachmenu, index) => (
            <Col
              md={2}
              sm={5}
              xs={5}
              className="px-0"
              key={index}
              style={{ marginTop: "40px" }}
            >
              <Link
                to={eachmenu.Name != "Log Out" && eachmenu.Action}
                className={classes.thelinks}
                onClick={() => GetClickAction(eachmenu.Name, eachmenu.Action)}
              >
                <Card className={classes.thecards}>
                  <Card.Body className="justify-content--around ">
                    <img src={eachmenu.Picture} className={classes.theIcons} />
                  </Card.Body>
                  <Card.Footer
                    style={{
                      paddingLeft: "0em",
                      textAlign: "center",
                      borderLeft: "3px groove brown",
                    }}
                  >
                    {eachmenu.Name}
                  </Card.Footer>
                </Card>
              </Link>
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  );
};

export default MenuDisplayPage;
